import { BottomSheet, IconArrowUpRightLine, IconReportLine, MenuSheetItem } from "@hamlak/ui";
import { t } from "@/i18n/ko";
import "./plotMenuSheet.css";

type Props = {
  open: boolean;
  onReport: () => void;
  onShare: () => void;
  onClose: () => void;
};

/** 플롯 프로필 헤더 ⋯(Figma 96:3660, AC0-270): 신고하기 · 공유하기. */
export function PlotMenuSheet({ open, onReport, onShare, onClose }: Props) {
  return (
    <BottomSheet open={open} onClose={onClose} data-testid="plot-menu-sheet">
      <div className="plot__menuList">
        <MenuSheetItem icon={<IconReportLine />} label={t("plot.menu.report")} onClick={onReport} />
        <MenuSheetItem icon={<IconArrowUpRightLine />} label={t("plot.menu.share")} onClick={onShare} />
      </div>
    </BottomSheet>
  );
}
